import React from 'react';

const TimePicker = ({
  value,
  onChange,
  className = '',
  startTime = '00:00',
  endTime = '23:45',
  selectedDate = null,
  timeOptions = [],
}) => {
  return (
    <div className="relative w-full">
      <select
        className={`time-dropdown w-full px-4 py-[12px] border border-[#e2e8f0] focus:border-gray-900 rounded-full appearance-none bg-white pr-10 ${className}`}
        value={value}
        onChange={(e) => onChange(e.target.value)}
      >
        {timeOptions.map((time) => (
          <option key={time.value} value={time.value} disabled={time.disabled}>
            {time.label || time.value}
          </option>
        ))}
      </select>
      <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
        <i className="fa fa-clock text-gray-700" />
      </div>
    </div>
  );
};

export default TimePicker;
